export const kvsSessionDurationM = 60; // KVS session duration(EndTimestamp = StartTimestamp + kvsSessionDurationM) in minutes
export const DEFAULT_TIME_RANGE = 1; // Default selected time range Home seek
export const TIME_RANGE_DURATION = 30; // Minutes of Home seek each hour range
export const Unwanted_Pause_Timeout_Duration_Ms = 5000; // Unwanted pause timeout diration in Ms
export const VDA4ErrorMaxDuration = 30000; // Max duration for occuuring VDA4 error in Ms
export const GetHLSStreamingSessionURLRetryInterval = 30000; // The retry interval for `GetHLSStreamingSessionURL` call in Ms
export const AllCamerasIdGroup = 0;
export const EVENT_BOUNDARY_OFFSET_MS = 5; // Offset in milliseconds to ensure event detection after boundary
